import React, { useState, useEffect } from 'react';
import {
  IconButton,
  Input,
  InputGroup,
  InputLeftElement,
  useColorModeValue,
} from '@chakra-ui/react';
import { SearchIcon } from '@chakra-ui/icons';
import { useSearch } from '../../../contexts/SearchContext';

export function SearchBar(props) {
  const { variant, background, placeholder, borderRadius, ...rest } = props;

  const searchIconColor = useColorModeValue('gray.700', 'white');
  const inputBg = useColorModeValue('secondaryGray.300', 'navy.900');
  const inputText = useColorModeValue('gray.700', 'gray.100');

  const { searchQuery, updateSearchQuery } = useSearch();
  const [query, setQuery] = useState(searchQuery || '');

  useEffect(() => {
    setQuery(searchQuery || '');
  }, [searchQuery]);

  const handleInputChange = (e) => {
    const value = e.target.value;
    setQuery(value);
    // Al vaciar el input se limpia el filtro sin necesidad de Enter
    if (value === '' && searchQuery !== '') {
      updateSearchQuery('');
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      updateSearchQuery(query);
    }
  };

  const handleIconClick = () => {
    updateSearchQuery(query);
  };

  return (
    <InputGroup w={{ base: '100%', md: '200px' }} {...rest}>
      <InputLeftElement>
        <IconButton
          bg="inherit"
          borderRadius="inherit"
          _hover="none"
          _active={{
            bg: 'inherit',
            transform: 'none',
            borderColor: 'transparent',
          }}
          _focus={{ boxShadow: 'none' }}
          icon={<SearchIcon color={searchIconColor} w="15px" h="15px" />}
          onClick={handleIconClick}
          aria-label="Buscar"
        />
      </InputLeftElement>
      <Input
        variant="search"
        fontSize="sm"
        bg={background || inputBg}
        color={inputText}
        fontWeight="500"
        _placeholder={{ color: 'gray.400', fontSize: '14px' }}
        borderRadius={borderRadius || '30px'}
        placeholder={placeholder || 'Buscar y presionar Enter...'}
        value={query}
        onChange={handleInputChange}
        onKeyDown={handleKeyDown}
      />
    </InputGroup>
  );
}
